import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { BaseForm } from 'xrk-components';
import { useRouteQuery } from '@V/bi-tmpl/src/hooks';
import { useBiTmplDetailSteup } from '@V/bi-tmpl/src/store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-form',
  setup(__props) {

const store = useBiTmplDetailSteup();
const { state } = storeToRefs(store);

const { isCheck } = useRouteQuery();

// 查看与不展示禁止操作。主题菜单101除了查看，其他情况必选
const disabled = computed(() => {
  return (
    isCheck ||
    (state.value.activeMenu[0] !== '101' && !state.value.curMenu.show)
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    class: "bi-form",
    disabled: disabled.value
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", { disabled: disabled.value })
    ]),
    _: 3
  }, 8, ["disabled"]))
}
}

})